module.exports = __webpack_public_path__ + "img/work2021multivision.5c3ea834.gif";